import { resizeV2 } from 'utils/image';
import MobileFileUpload from 'pages/ListerVehicleUploadV2/FileUploadPrompt';
import { ImageField } from '../../../../services/api/upload-vehicle';
import { parseFile } from 'utils/file';
import { FieldRenderProps } from 'react-final-form';
import { NoAutoSavePhoto } from 'pages/ListerVehicleUploadV2/components/photos/NoAutoSaveImage';
import { useCameraViewContext } from 'pages/ListerVehicleUploadV2/CameraView/context';

export const RenderInitialImage = (props: FieldRenderProps<ImageField> & { index: number }) => {
  const { input, index } = props;
  const handleFileChange = async (file: File) => {
    if (!file) return;
    const parsedFile = await parseFile(file);
    const resized = await resizeV2(parsedFile, { width: 1600, height: 1200 }, 'jpeg', 1);
    input.onChange({
      ...input.value,
      file: resized,
      local_url: URL.createObjectURL(resized)
    });
  };

  const { openCameraView } = useCameraViewContext();

  const onCameraSelected = () => {
    openCameraView('data', index, false, undefined);
  };

  return (
    <MobileFileUpload accept="image/*" onCustomCamera={onCameraSelected} onFileSelected={handleFileChange}>
      <NoAutoSavePhoto {...props} disableFilePrompt key={props.input.name} />
    </MobileFileUpload>
  );
};
